.#{$namespace}-popper {
	// 描边色
	$shadow-color: #{alpha-color($black-color, 12%)};
	// 箭头配置
	--arrow-size: 12px;
	--arrow-inset: calc(var(--arrow-size) / 4); // 后退距离，防止遮住激活组件

	position: fixed;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	.popper-arrow {
		position: relative;
		overflow: hidden;
		&::before {
			position: absolute;
			content: '';
			width: var(--arrow-size);
			height: var(--arrow-size);
			background-color: $white-color;
			border-radius: 2px;
			transform-origin: center center;
			transform: rotate(45deg);
			box-shadow: 0 0 1px 1px #{$shadow-color};
			z-index: 2;
		}
	}
	.popper-content {
		overflow: hidden;
		border-radius: 8px;
		background-color: $white-color;
		box-shadow: 0 0 1px 1px #{$shadow-color};
	}
	&.is-top {
		flex-direction: column-reverse;
		.popper-arrow {
			&::before {
				bottom: calc(var(--arrow-size) * -1);
			}
		}
	}
	&.is-bottom {
		.popper-arrow {
			&::before {
				top: var(--arrow-inset);
			}
		}
	}
	&.is-top,
	&.is-bottom {
		.popper-arrow {
			height: calc(var(--arrow-size) / 1.5);
		}
		&:not(.is-start):not(.is-end) {
			.popper-arrow {
				&::before {
					left: calc(50% - var(--arrow-inset) / 2);
				}
			}
		}
		&.is-start {
			.popper-arrow {
				&::before {
					left: calc(var(--arrow-inset) * 5);
				}
			}
		}
		&.is-end {
			.popper-arrow {
				&::before {
					right: calc(var(--arrow-inset) * 5);
				}
			}
		}
	}

	&.is-plain {
		.popper-arrow {
			display: none;
		}
		.popper-content {
			overflow: visible;
			border-radius: 0;
			background: transparent;
			box-shadow: none;
		}
	}
}

.#{$namespace}-popper-enter-active,
.#{$namespace}-popper-leave-active {
	transition:
		opacity 0.2s ease,
		transform 0.2s ease;
}

.#{$namespace}-popper-enter-from,
.#{$namespace}-popper-leave-to {
	opacity: 0;
}

.#{$namespace}-popper {
	&.is-bottom.#{$namespace}-popper-enter-from,
	&.is-bottom.#{$namespace}-popper-leave-to {
		transform: translateY(-6px);
	}
	&.is-top.#{$namespace}-popper-enter-from,
	&.is-top.#{$namespace}-popper-leave-to {
		transform: translateY(6px);
	}
	&.is-left.#{$namespace}-popper-enter-from,
	&.is-left.#{$namespace}-popper-leave-to {
		transform: translateX(6px);
	}
	&.is-right.#{$namespace}-popper-enter-from,
	&.is-right.#{$namespace}-popper-leave-to {
		transform: translateX(-6px);
	}
}
